import React, { useState, useEffect } from "react";
import Axios from "axios";
import "./../../../../assets/css/purchase/form.css";
// React DateTime
import Datetime from "react-datetime";
import moment from "moment";
// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import FormAction from "../../../components/Actions/FormAction";
import {
  deleteData,
  getAlert,
  insertData,
  parseCurrency,
  updateData,
} from "../../../../utils/SamuiUtils";

const Form = ({
  callInitialize,
  mode,
  name,
  formData,
  setFormData,
  selectedData,
  dataEmpPosition,
  dataEmpDept,
}) => {
  const [initialFormData, setInitialFormData] = useState({});

  useEffect(() => {
    const compId = localStorage.getItem("company");
    if (compId) {
      setFormData((prevData) => ({
        ...prevData,
        comp_id: compId,
      }));
    }
  }, [setFormData]);

  useEffect(() => {
    if (mode === "I") {
      const initialData = {
        Car_No: "",
        Car_Name: "",
        Car_Status: "Y",
        Car_Remark: "",
        comp_id: parseCurrency(window.localStorage.getItem("company"), 10),
      };
      setFormData(initialData);
      setInitialFormData(initialData);
    } else if (mode === "U") {
      const initialData = {
        Car_id: parseCurrency(selectedData.Car_id, 10),
        Car_No: selectedData.Car_No,
        Car_Name: selectedData.Car_Name,
        Car_Remark: selectedData.Car_Remark,
        Car_Status: selectedData.Car_Status,
        comp_id: parseCurrency(window.localStorage.getItem("company"), 10),
      };
      setFormData(initialData);
      setInitialFormData(initialData);
    }
  }, [mode, setFormData, selectedData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleInsertEmployee = async () => {
    try {
      const { Car_id, ...dataToInsert } = formData;
      const fields = Object.keys(dataToInsert).join(", ");
      const values = Object.values(dataToInsert);

      const res = await insertData("Tb_Set_Car", fields, values);

      if (res?.status === "OK") {
        getAlert("OK", "บันทึกสำเร็จ");
        callInitialize();
      } else {
        getAlert("FAILED", res?.message || "ไม่สามารถบันทึกข้อมูลได้");
      }
    } catch (error) {
      console.error("Error inserting employee:", error);
      getAlert(
        "FAILED",
        "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว"
      );
      return null;
    }
  };
  const formatValues = (data) => {
    const { Car_id, ...rest } = data;
    return rest;
  };

  const handleUpdateEmployee = async () => {
    try {
      const where = { Car_id: formData.Car_id };
      const values = formatValues(formData);
      const res = await updateData("Tb_Set_Car", values, where);
      if (res) {
        getAlert("OK", "อัปเดตข้อมูลสำเร็จ");
        callInitialize();
      }
    } catch (error) {
      getAlert(
        "FAILED",
        "ไม่สามารถอัปเดตข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว"
      );
      return null;
    }
  };

  const handleDelete = async () => {
    try {
      getAlert("C_DIALOG", "ยืนยันการลบข้อมูล", async (isConfirm) => {
        if (isConfirm) {
          await deleteData("Tb_Set_Car", `WHERE Car_id = ${selectedData.Car_id}`);
          getAlert("OK", "ลบข้อมูลสำเร็จ");
          await callInitialize();
        }
      })
    } catch (error) {
      getAlert("FAILED", "ไม่สามารถลบข้อมูลได้ กรุณาลองใหม่อีกครั้ง");
    }
  };

  const handleSubmit = async (e) => {
    try {
      if (mode === "I") {
        await handleInsertEmployee();
      } else if (mode === "U") {
        await handleUpdateEmployee();
      }
      await callInitialize();
      setFormData({
        emp_id: "", // Int
        Car_id: 0,
        Car_No: "",
        Car_Name: "",
        Car_Status: "Y",
        Car_Remark: "",
        comp_id: parseCurrency(window.localStorage.getItem("company"), 10), // Ensure comp_id is a number
      });
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      getAlert(
        "WARNING",
        "โปรดตรวจสอบข้อมูลอีกครั้ง ข้อมูลนี้มีอยู่ในระบบแล้ว"
      );
      return null;
    }
  };

  return (
    <form>
      <Breadcrumbs
        isShowStatus={mode === "U"}
        items={[
          { name: "ข้อมูลตั้งต้น", url: "/initialdata" },
          { name: name, url: "/car" },
          { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
        ]}
      />
      <div className="container p-4">
        <div className="card shadow-sm ">
          <div className="card-body">
            <div className="row g-3 mt-1 px-3">
              <div className="col-12">
                <label className="">ทะเบียนรถ</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="Car_No"
                  value={formData.Car_No || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-12 mt-2">
                <label className="">ชื่อรถ</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="Car_Name"
                  value={formData.Car_Name || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-12 mt-2">
                <label className="">หมายเหตุ</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="Car_Remark"
                  value={formData.Car_Remark || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-12 mt-2">
                <label className="">สถานะ</label>
                <select
                  className="form-select"
                  name="Car_Status"
                  value={formData.Car_Status || "Y"} // Set default value to "Y"
                  onChange={handleChange}
                  style={{ color: "black" }}
                >
                  <option value="Y">ใช้งาน</option>
                  <option value="N">ไม่ใช้งาน</option>
                </select>
              </div>
            </div>
            <div className="row mt-4">
              {mode !== "I" ? (
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  {/* ปุ่มลบ */}
                  <button
                    onClick={() => handleDelete()}
                    type="button"
                    className="btn btn-lg shadow text-white"
                    style={{
                      width: "8%",
                      backgroundColor: "#dc3545",
                      fontSize: "16px",
                    }}
                  >
                    ลบ
                  </button>

                  {/* กลุ่มปุ่มยกเลิก และบันทึก */}
                  <div style={{ display: "flex", gap: "20px" }}>
                    <button
                      onClick={() => (window.location.href = "/car")}
                      type="button"
                      className="btn btn-lg shadow text-white"
                      style={{
                        backgroundColor: "#000000",
                        fontSize: "16px",
                      }}
                    >
                      ยกเลิก
                    </button>
                    <button
                      onClick={() => handleUpdateEmployee()}
                      type="button"
                      className="btn btn-lg shadow text-white"
                      style={{
                        backgroundColor: "#EF6C00",
                        fontSize: "16px",
                      }}
                    >
                      บันทึก
                    </button>
                  </div>
                </div>
              ) : (
                <div style={{ display: "flex" }}>
                  <FormAction
                    onSubmit={handleSubmit}
                    onUpdate={handleSubmit}
                    onDelete={handleDelete}
                    mode={mode}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default Form;
